import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Seeder from './pages/Seeder';
import About from './pages/About';
import MapEmbed from './pages/Embed';

function App() {
  return (
    <Router>
      <div className="flex-column height-total">
        <div className="header flex-row flex-align-center">

        </div>
        <div className="flex-row flex-grow-1 overflow-auto">
          <Switch>
            <Route path="/">
              <MapEmbed />
            </Route>
          </Switch>
        </div>
      </div>
    </Router>
  );
}

export default App;
